/* eslint-disable */
import { utilCookies } from '@/util/cookies'
import { lang } from '@/lang'

const state = {
  showSettings: false,
  fixedHeader: true,
  sidebarLogo: false,
  contentViewHeight: 0,
  langArr: lang.langList,
  curLang: lang.curLang,
  // 主题色
  themeColor: null
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  },
  updateContentViewHeight(store, height) {
    store.contentViewHeight = height
  },
  updateCurLang(store, data) {
    store.curLang = data
    utilCookies.setLanguage(data['key'])
    window.location.reload()
  },
  // 主题色
  CHANGE_COLOR: (store, val) => {
    store.themeColor = val
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
